module.exports = require("../../../utilities/Clipboard");